import { Fragment, ReactElement } from 'react';
import ResearchDeathNotificationResidentCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death';

const ResearchDeathNotificationResidentCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNotificationResidentCivilStatusShared />
    </Fragment>
  );
};

ResearchDeathNotificationResidentCivilStatusPage.displayName =
  'Research Marriage Notifications Resident Page component';

export default ResearchDeathNotificationResidentCivilStatusPage;
